export default __webpack_public_path__ + "static/media/hero-mobile-NZ.2464a60d.png";